export default {
	LOAD_DONE: 'USER.LOAD.DONE',
};



// WEBPACK FOOTER //
// ./src/actionTypes/user.actionTypes.js